import http from "../http/http-config";
import { InsurableAmount } from "../models/InsurableAmount";

export default new class GetInsurableAmountsService {
    getInsurableAmount(article, squareMetersToInsure): Promise<InsurableAmount[]> {
        return http.get<InsurableAmount[]>("GetInsurableAmounts", {
            params: {
                article,
                squareMetersToInsure
            }
        }).then(response => response.data)
    }
}